import { AxiosError } from "axios";

export class ErrorWrapper extends Error {
  public name = "ErrorWrapper";
  public stack = new Error().stack;
  public success: boolean;
  public status: number | boolean;
  public statusMessage: string;
  public raw: any;

  constructor(error: AxiosError) {
    super();
    this.raw = error;
    this.success = error.response?.data?.response?.success ?? false;
    this.status = error.response?.status ?? 0;
    this.statusMessage = this.getStatusMessage(this.status);
    this.message = this.getResponseErrorMessage(error);
  }

  private getResponseErrorMessage(error: AxiosError): string {
    return (
      error.response?.data?.response?.message ??
      error.message ??
      "Unhandled error occurred"
    );
  }

  private getStatusMessage(status: number): string {
    const successMsg = "Request Successful";
    const statusMessages: Record<number, string> = {
      200: successMsg,
      201: successMsg,
      400: "Bad Request",
      401: "Authentication Required",
      404: "Not Found",
      503: "Service Unavailable"
    };

    return statusMessages[status] ?? "Unknown Error";
  }
}
